import { render, staticRenderFns } from "./application-sidebar-layout.vue?vue&type=template&id=86e47b80&scoped=true"
import script from "./application-sidebar-layout.vue?vue&type=script&lang=ts"
export * from "./application-sidebar-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e47b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86e47b80')) {
      api.createRecord('86e47b80', component.options)
    } else {
      api.reload('86e47b80', component.options)
    }
    module.hot.accept("./application-sidebar-layout.vue?vue&type=template&id=86e47b80&scoped=true", function () {
      api.rerender('86e47b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/layouts/application-sidebar-layout.vue"
export default component.exports